import { ampli } from 'lib-shared-tracking';

import { api } from 'app/app.api';

import {
  ApprovePairingArg,
  ApprovePairingResponse,
  InitiateFromDixaArg,
  InitiateFromDixaResponse,
  ReadPairingDetailsArg,
  ReadPairingDetailsResponse,
} from './types/partnerIntegrationsPairingApi.types';

/** RTK Query endpoints for integration pairing. */
export const partnerIntegrationsPairingApi = api.injectEndpoints({
  endpoints: (builder) => ({
    readPairingDetails: builder.query<
      ReadPairingDetailsResponse,
      ReadPairingDetailsArg
    >({
      query: ({ pairingCode, subdomain }) => ({
        type: 'partnerIntegrations',
        path: 'integrations/pairing/details',
        params: { pairingCode },
        headers: {
          'x-dixa-subdomain': subdomain,
        },
      }),
    }),
    approvePairing: builder.mutation<ApprovePairingResponse, ApprovePairingArg>(
      {
        query: ({ pairingCode, subdomain }) => ({
          type: 'partnerIntegrations',
          method: 'POST',
          path: 'integrations/pairing/approve',
          body: { pairingCode },
          headers: {
            'x-dixa-subdomain': subdomain,
          },
        }),
        async onQueryStarted(_arg, { queryFulfilled }) {
          try {
            const { data: response } = await queryFulfilled;

            // Using the previous tracking event for the new auth flow to have all integraiton installs together in the same Amplitude graphs.
            ampli.partnerIntegrationsSettingsCreateSubmitted({
              widgetType: response.data.integrationType,
            });
          } catch {
            // Approval failures are surfaced by the calling components.
          }
        },
      },
    ),
    initiateFromDixa: builder.mutation<
      InitiateFromDixaResponse,
      InitiateFromDixaArg
    >({
      query: ({ integrationType, subdomain }) => ({
        type: 'partnerIntegrations',
        method: 'POST',
        path: `integrations/${integrationType}/pairing/initiate-from-dixa`,
        headers: {
          'x-dixa-subdomain': subdomain,
        },
      }),
    }),
  }),
});
